import React from 'react'
import { CircularProgress } from 'react-md'

import './index.css'

const LoadingOverlay = () => (
  <div className='loadingOverlay'>
    <CircularProgress id='loadingOverlay' key='progress' scale={2} />
  </div>
)

export default LoadingOverlay



// WEBPACK FOOTER //
// ./src/components/LoadingOverlay/index.js